module.exports = __webpack_public_path__ + "static/media/HomeIcon.8e2b1779.svg";